/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MailMethod = 'Undefined' | 'PAPIR' | 'EMAIL' | 'B2B' | 'B2C' | 'EBILL' | 'FA24' | 'XLSX' | 'CSV' | 'Neodesilat' | 'OdeslaniNaTieto' | 'OdeslaniNaDS' | 'ISDOC';

export const MailMethod = {
    Undefined: 'Undefined' as MailMethod,
    PAPIR: 'PAPIR' as MailMethod,
    EMAIL: 'EMAIL' as MailMethod,
    B2B: 'B2B' as MailMethod,
    B2C: 'B2C' as MailMethod,
    EBILL: 'EBILL' as MailMethod,
    FA24: 'FA24' as MailMethod,
    XLSX: 'XLSX' as MailMethod,
    CSV: 'CSV' as MailMethod,
    Neodesilat: 'Neodesilat' as MailMethod,
    OdeslaniNaTieto: 'OdeslaniNaTieto' as MailMethod,
    OdeslaniNaDS: 'OdeslaniNaDS' as MailMethod,
    ISDOC: 'ISDOC' as MailMethod
};